export default __webpack_public_path__ + "static/media/UpgradePlanImage.04641354.svg";